// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorResponseModel {
    static getAttributeTypeMap() {
        return PayorResponseModel.attributeTypeMap;
    }
}
PayorResponseModel.discriminator = undefined;
PayorResponseModel.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=payorResponseModel.js.map